import React, {useEffect, useState} from "react";
import SortingHistoryShowData from "./ui/showData";
import {ThaiDatepicker} from "../../../Components/Datepicker/thai-datepicker";
import useUpdateHistoryData from "./hooks/use-sorting-history-report-data";
import {useParams} from "react-router";
import Pagination from "@material-ui/lab/Pagination";
import {Spinner} from "react-bootstrap";
import useUpdateHistoryReportData from "./hooks/use-sorting-history-report-data";
import {useTranslation} from "react-i18next";
import * as Icon from "react-bootstrap-icons";
import { Typeahead } from "react-bootstrap-typeahead";
import ReactExport from "react-data-export";
import {DimensionValidate, editHistoryReportExcel, HubListService,GetSortingList} from "../../../Service/service.Parcels";
import { useHistory } from "react-router-dom";
import { swalSuccess, swalError } from "../../../Components/sweetAlert";
import useSortingHistoryReportData from "./hooks/use-sorting-history-report-data";


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const SortingHistoryReport = () => {
    const history = useHistory();
    var year = new Date().getFullYear();
    var years = Array.from(new Array(3), (e, index) => year - index);
    var month = new Date().getMonth()+1;
    var day = new Date().getDate();
    var dayStr = day<10? '0'+day:day;
    var date = new Date().getDate();
    const [currentPage, setCurrentPage] = useState(1);
    // const [dataExport, setDataExport] = useState([]);
    const {data,dataExport,error,loading,loadingExcel,fetchData,fetchDataExcel,dataOutput} = useSortingHistoryReportData();
    const params = useParams();
    const [dataExcel,setDataExcel] = useState([]);
    const [search,setSearch] = useState('');
    const [cust_code,setCustCode] = useState('');
    const [startDate,setStartDate] = useState(''+year+"-"+month+"-"+dayStr+" "+"00:00:00");
    const [endDate,setEndDate] = useState(''+year+"-"+month+"-"+dayStr+" "+"23:59:59");
    const [cust, Cust] = useState([]);
    const [customer_type, Customer_type] = useState("");
     
    useEffect(() => {
        if((localStorage.getItem("superkey")!=="admin" 
        && localStorage.getItem("superkey")!=="conveyor")  
        || !localStorage.getItem("superkey")){
          history.push("/notAvailable");
        }
        fetchData(search,currentPage,startDate,endDate);
      }, [currentPage]);

    const handleChangePage = (_evt,newPage) => {
      setCurrentPage(newPage);
    };

    async function CustomerType(data) {
        const result = await HubListService(data);
        if (data != null) {
            Cust(result.data);
        }
    }

    async function handleSubmit2Excel(){
        fetchDataExcel(search,cust_code,startDate,endDate)
    }

    async function validateDimension(id){
        try {
            let result = await DimensionValidate({id: id, custcode: localStorage.getItem("username")});
            if (result.status === 0) {
                swalError();
            } else {
            // setData([]);
            // setErrorMassNoData([])
                swalSuccess();
                fetchData(search, currentPage,startDate,endDate);
            }
        }
        catch (e) {
            swalError({
            text: t(e.response.data.message),
            });
        }
    
    }

    async function editDimension(data){
        
    }

    async function getDataExcel(search,cust_code,start_date,end_date){
        try{
            // setLoadingExcel(true);
                let result = await GetSortingList({page: currentPage,maxPage: 0,search: search});
                alert(JSON.stringify(result))
                setDataExcel(result.data===false?[]:result.result.result);

        }
        catch (e) {
            console.error(e);
            alert(e)
            // setError('An error occured');
        }
        finally {
            document.getElementById("downloadEx1").click();
            // setLoadingExcel(false);
        }
    }

    const {t} = useTranslation();
    
    return (
        <>
            <center><h1>Sorting history</h1></center>
            <div style={{ overflow: 'auto', width: '100%' }}>
                <div className=""></div>
                {!loading && data && (
                    <div className="center">
                        <div className="w-100">
                            {/* Top Row: Search + Customer Type + Typeahead */}
                            <div className="row g-2">

                                {/* Customer Type Select */}
                                {localStorage.getItem("superkey")!=="credit"?
                                (<div className="col-12 col-md-6">
                                    <div className="row">
                                    <div className="col-12 col-md-5">
                                        <label className="form-label d-block">ประเภทลูกค้า</label>
                                        <select
                                        value={customer_type}
                                        onChange={(e) => {
                                            Customer_type(e.target.value);
                                            CustomerType({ customer_type: e.target.value });
                                        }}
                                        className="form-control"
                                        >
                                        <option value={""}>ประเภทผู้ใช้</option>
                                        <option value={"10"}>Hub</option>
                                        </select>
                                    </div>

                                    {/* Typeahead */}
                                    <div className="col-12 col-md-5">
                                        <label className="form-label">รหัสลูกค้า</label>
                                        <div className="input-group flex-nowrap">
                                        <Typeahead
                                            id="basic-typeahead-single"
                                            onChange={(selected) => {
                                                setCustCode(selected?.[0]?.cust_code ?? '');
                                                setSearch(selected?.[0]?.cust_code ?? '');
                                            }}
                                            options={cust}
                                            labelKey={(option) => `${option.cust_code} ${option.name}`}
                                            placeholder="ชื่อ"
                                            selected={cust_code ? [{ cust_code, name: '' }] : []}
                                        />
                                        </div>
                                    </div>
                                    </div>
                                </div>):(<></>)
                                }

                                {/* Search */}
                                <div className="col-12 col-md-6">
                                    <label className="form-label">ค้นหา</label>
                                    <input
                                    className="form-control"
                                    value={search}
                                    placeholder=""
                                    onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>

                                </div>

                            {/* Second row: Date pickers + Button */}
                            <div className="row g-3 align-items-end mt-1">
                                <div className="col-12 col-lg-4">
                                    <div className="form-group">
                                        <ThaiDatepicker
                                        isTimePicker={true}
                                        label={t('hub.filters.startDate')}
                                        date={startDate}
                                        onChange={(date) => {
                                            setStartDate(new Date(date).toISOString().slice(0, 19).replace("T", " "));
                                        }}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-lg-4">
                                    <div className="form-group">
                                        <ThaiDatepicker
                                        isTimePicker={true}
                                        label={t('hub.filters.endDate')}
                                        date={endDate}
                                        onChange={(date) => {
                                            setEndDate(new Date(date).toISOString().slice(0, 19).replace("T", " "));
                                        }}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-lg-4">
                                    {/* Make button full width on small screens, nicely aligned on large */}
                                    <div className="d-grid">
                                        <button
                                        type="button"
                                        className="btn btn-primary w-100"
                                        onClick={() => {
                                            fetchData(search, 1,startDate,endDate);
                                        }}
                                        >
                                        <Icon.Search /> {t('common.search')}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="row g-3 align-items-center mt-1">
                                <div className="col-12 col-lg-4">
                                    <div className="d-grid">
                                        <span>
                                            <button className="btn btn btn-info" onClick={ async (e)=>{
                                                    // await handleSubmit2Excel();
                                                    await getDataExcel(search,localStorage.getItem("superkey")==="credit"?localStorage.getItem("username"):cust_code,startDate,endDate);
                                                    // alert(JSON.stringify(dataExport));
                                                    // if(!loadingExcel){
                                                    //     // document.getElementById("downloadEx1").click();
                                                    // }
                                
                                                }}><Icon.FileEarmarkArrowUp /> export</button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                        <ExcelFile
                            element={
                                // <button style={{ display: "none" }} id="downloadEx">
                                <button style={{display: "none"}} className="btn btn-primary" id="downloadEx1">
                                Download Data
                                </button>
                            }
                            filename="dimension History"
                            >
                            <ExcelSheet data={dataExcel} name={"COD History"}>
                                <ExcelColumn label="เลขลาเบล" value="awb_code" />
                                <ExcelColumn label="machine_code" value="device_code" />
                                <ExcelColumn label="sort date" value="sort_date" width={{ wpx: 300 }}/>
                                <ExcelColumn label="sortingPort" value="sortingPort" />
                                
                            </ExcelSheet>
                        </ExcelFile>

                            {dataOutput!==null && dataOutput?
                                (
                                    <div className="row">
                                        <div className="col col-lg-2">
                                            <h6 className="m-1"> conveyor: {dataOutput[0].device_code}</h6>
                                        </div>
                                        <div className="col col-lg-2">
                                            <h6 className="m-1"> last update : {dataOutput[0].created_date} </h6>
                                        </div>
                                        <div className="col col-lg-2">
                                            <h6 className="m-1"> output 1: {dataOutput[0].output1} </h6>
                                        </div>
                                        <div className="col col-lg-2">
                                            <h6 className="m-1"> output 2: {dataOutput[0].output2} </h6>
                                        </div>
                                        <div className="col col-lg-2">
                                            <h6 className="m-1"> output 3: {dataOutput[0].output3} </h6>
                                        </div>
                                                
                                    </div>
                                    
                                ):(<></>)
                            }
                        <SortingHistoryShowData page={currentPage} data={data.result} validateDimension={validateDimension}/>
                        <Pagination
                            count={data.maxPage}
                            page={currentPage}
                            onChange={handleChangePage}
                            color="primary"
                            size="small"
                            defaultPage={1}
                            siblingCount={1}
                        />
                    </div>
                )}
                {loading && <div className="spinner-global-content">
                    <Spinner variant="success" animation="border" />
                </div> }
            </div>
        </>
    )
}
export default SortingHistoryReport;